import { Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useMemo } from 'react'
import { useScheduleItems } from '../../Context/ScheduleItems/ScheduleItemsContext'

export interface ShiftTotalsDisplayProps {
  dayKey: string
  title?: string
  isToday?: boolean
}

export function ShiftColumnHeader({ dayKey, title, isToday }: ShiftTotalsDisplayProps) {
  const { search } = useScheduleItems()
  const { amShifts, pmShifts, errorShifts } = useMemo(
    () =>
      search({ index: 'day', value: dayKey }).reduce(
        (result, item) => ({
          pmShifts: item.shift === 'pm' ? result.pmShifts + 1 : result.pmShifts,
          amShifts: item.shift === 'am' ? result.amShifts + 1 : result.amShifts,
          errorShifts: item.errors.length ? result.errorShifts + 1 : result.errorShifts,
        }),
        { pmShifts: 0, amShifts: 0, errorShifts: 0 }
      ),
    [search, dayKey]
  )

  return (
    <Vertical flex='1' alignItems='center' gap={0} border='right' style={{ overflow: 'visible' }}>
      {title && (
        <Horizontal
          flex={0}
          border='bottom'
          style={{ width: '100%', height: '36px' }}
          justifyContent='center'
          verticalCenter
          gap={4}
        >
          <Texto weight='bold' appearance={isToday ? 'primary' : 'default'}>
            {title}
          </Texto>
        </Horizontal>
      )}

      <Horizontal
        flex={1}
        gap={8}
        width='100%'
        style={{ overflow: 'visible', flexWrap: 'wrap' }}
        justifyContent='center'
        verticalCenter
      >
        <div className='aggregation'>
          <MaterialIcon icon='wb_sunny' style={{ color: 'var(--theme-warning)' }} />
          <Texto>{amShifts}</Texto>
        </div>

        <div className='aggregation'>
          <MaterialIcon icon='dark_mode' style={{ color: 'var(--theme-primary)' }} />
          <Texto>{pmShifts}</Texto>
        </div>
        <div className='aggregation'>
          <MaterialIcon icon='warning' style={{ color: 'var(--theme-error)' }} />
          <Texto>{errorShifts}</Texto>
        </div>
      </Horizontal>
    </Vertical>
  )
}
